export interface IAuthStoreState {
  accessToken: string
  refreshToken: string
  uid: string
  email: string
  sessionExpired: boolean
  editProfile: boolean
  loggedInUser: any
}

export const useAuthStore = defineStore('auth', {
  state: (): IAuthStoreState => ({
    accessToken: '',
    refreshToken: '',
    uid: '',
    email: '',
    sessionExpired: false,
    editProfile: false,
    loggedInUser: null,
  }),

  getters: {
    getEditProfile(state) {
      return state.editProfile
    },

    user(state) {
      return state.loggedInUser
    },

    isAdmin(state) {
      if (state.loggedInUser && state.loggedInUser.role) {
        return state.loggedInUser.role === 'Admin'
      }
      return false
    },
  },

  actions: {
    setEditProfile(status: boolean) {
      this.editProfile = status
    },

    setUser(payload: any) {
      this.loggedInUser = payload
    },
  },

  persist: {
    storage: piniaPluginPersistedstate.localStorage(),
  },
})
